import { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { format } from "date-fns-jalali";
import Logo from "../Images/favicon.png";
import DetailsIcon from "../Images/Icons/Details.png";
import SettingsIcon from "../Images/Icons/Settings.png";
import TradeIcon from "../Images/Icons/Trade.png";
import TransferIcon from "../Images/Icons/Transferm.png";
import WalletIcon from "../Images/Icons/wallet.png";

function TabIcon({ type }) {
  const icons = {
    statement: DetailsIcon,
    transfer: TransferIcon,
    trades: TradeIcon,
    balance: WalletIcon,
    settings: SettingsIcon,
  };

  return (
    <img src={icons[type] || SettingsIcon} alt="" aria-hidden="true" />
  );
}

function TopNavigator() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [currentDate, setCurrentDate] = useState({ dayName: "", dateStr: "" });
  const menuRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userData = localStorage.getItem("user");

    if (token && userData) {
      try {
        setUser(JSON.parse(userData));
      } catch (error) {
        console.error("Error parsing user data:", error);
        setUser(null);
      }
      return;
    }

    setUser(null);
  }, []);

  useEffect(() => {
    const today = new Date();
    const dayName = new Intl.DateTimeFormat("fa-IR-u-ca-persian", {
      weekday: "long",
    }).format(today);
    const dateStr = format(today, "yyyy/MM/dd");
    setCurrentDate({ dayName, dateStr });
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuOpen]);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setMenuOpen(false);
        setAuthModalOpen(false);
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
    setMenuOpen(false);
    navigate("/");
    window.location.reload();
  };

  const menuItems = [
    { path: "/balance", icon: "💰", label: "موجودی حساب" },
    { path: "/transfer", icon: "💸", label: "ثبت حواله" },
    { path: "/transactions", icon: "📜", label: "گردش حساب" },
    { path: "/price-changes", icon: "📈", label: "تغییرات قیمت امروز" },
    { path: "/settings", icon: "⚙️", label: "تنظیمات" },
  ];

  const bottomTabs = [
    { path: "/transactions", icon: "statement", label: "گردش حساب", requiresAuth: true },
    { path: "/transfer", icon: "transfer", label: "ثبت حواله", requiresAuth: true },
    { path: "/", icon: "trades", label: "معاملات", requiresAuth: false },
    { path: "/balance", icon: "balance", label: "موجودی حساب", requiresAuth: true },
    { path: "/settings", icon: "settings", label: "تنظیمات", requiresAuth: false },
  ];

  const isActivePath = (path) => {
    if (path === "/") {
      return location.pathname === "/";
    }

    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  const handleProtectedTabClick = (event, tab) => {
    if (!user && tab.requiresAuth) {
      event.preventDefault();
      setAuthModalOpen(true);
    }
  };

  return (
    <>
      <div className="Nav">
        <div className="container">
          <div className="RowNav">
            <div className="NavSide NavSideMenu">
              {!user ? (
                <Link to="/register" className="LoginBtn">
                  افتتاح حساب
                </Link>
              ) : (
                <div className="HamburgerMenu" ref={menuRef}>
                  <button
                    className={`HamburgerBtn ${menuOpen ? "Active" : ""}`}
                    onClick={() => setMenuOpen(!menuOpen)}
                    aria-label="منو"
                    aria-expanded={menuOpen}
                  >
                    <span className="Bar"></span>
                    <span className="Bar"></span>
                    <span className="Bar"></span>
                  </button>

                  <div className={`DropdownMenu ${menuOpen ? "Show" : ""}`}>
                    <div className="MenuHeader">
                      <div className="UserAvatar">
                        {user.firstName?.charAt(0) || user.name?.charAt(0) || "؟"}
                      </div>
                      <div className="UserDetails">
                        <span className="UserName">
                          {user.firstName} {user.lastName}
                        </span>
                        <span className="UserPhone">{user.phone || "شماره تماس"}</span>
                      </div>
                    </div>

                    <div className="MenuItems">
                      {menuItems.map((item) => (
                        <Link
                          key={item.path}
                          to={item.path}
                          className="MenuItem"
                          onClick={() => setMenuOpen(false)}
                        >
                          <span className="ItemIcon">{item.icon}</span>
                          <span className="ItemLabel">{item.label}</span>
                          <span className="ItemArrow">‹</span>
                        </Link>
                      ))}
                    </div>

                    <div className="MenuFooter">
                      <button className="LogoutBtn" onClick={handleLogout}>
                        <span className="BtnIcon">🚪</span>
                        <span>خروج از حساب</span>
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="NavCenter">
              <div className="LogoWrap">
                <span className="LogoHalo" aria-hidden="true"></span>
              </div>
              <div className="NavBrandText">
                <p className="NavEyebrow">تابلوی قیمت و معامله</p>
                <h1 className="NavTitle">عسگرپور</h1>
              </div>
            </div>

            <div className="NavSide NavSideDate">
              <div className="NavDateCard">
                <p className="NavDateDay">{currentDate.dayName}</p>
                <p className="NavDateValue">{currentDate.dateStr}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {authModalOpen && (
        <div className="AuthRequiredOverlay" onClick={() => setAuthModalOpen(false)}>
          <div className="AuthRequiredModal" onClick={(event) => event.stopPropagation()}>
            <button
              type="button"
              className="AuthRequiredClose"
              onClick={() => setAuthModalOpen(false)}
              aria-label="بستن"
            >
              ×
            </button>
            <span className="AuthRequiredIcon">
              <TabIcon type="settings" />
            </span>
            <h3>کاربر باید قبلا وارد شود</h3>
            <p>برای دسترسی به این بخش ابتدا وارد حساب کاربری خود شوید.</p>
            <div className="AuthRequiredActions">
              <Link to="/loginpage" className="AuthRequiredPrimary" onClick={() => setAuthModalOpen(false)}>
                ورود
              </Link>
              <button type="button" className="AuthRequiredSecondary" onClick={() => setAuthModalOpen(false)}>
                بستن
              </button>
            </div>
          </div>
        </div>
      )}

      <nav className={user ? "MobileBottomTabs" : "MobileBottomTabs guest"} aria-label="منوی پرتال کاربر">
        {bottomTabs.map((tab) => (
          <Link
            key={tab.path}
            to={tab.path}
            className={[
              isActivePath(tab.path) ? "MobileBottomTab active" : "MobileBottomTab",
              !user && tab.requiresAuth ? "locked" : "",
            ].filter(Boolean).join(" ")}
            aria-label={tab.label}
            title={tab.label}
            onClick={(event) => handleProtectedTabClick(event, tab)}
          >
            <span className="MobileBottomIcon">
              <TabIcon type={tab.icon} />
            </span>
          </Link>
        ))}
      </nav>
    </>
  );
}

export default TopNavigator;
